import dayjs from "@/lib/day";
import LogicaAPI from "./logicaapi";
class Terms extends LogicaAPI {
  async getTerm(key, withAgreement) {
    var _this$context;
    const params = {
      with_current_revision: true,
      ts: dayjs().unix()
    };
    if (withAgreement && (_this$context = this.context) !== null && _this$context !== void 0 && (_this$context = _this$context.req) !== null && _this$context !== void 0 && _this$context.userToken) {
      params["with_agreement"] = true;
    }
    return await this.get(`/api/v1/terms/${key}`, {
      params
    });
  }
  agree(key) {
    const params = {
      revision_unique_key: key
    };
    return this.post("/api/v1/terms/agree", {
      body: params
    });
  }
}
export default Terms;